import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';

export function Logout() {
  const auth0 = useAuth0();
  if (auth0.isAuthenticated) {
    auth0.logout({
      returnTo: window.location.origin,
    });
  }

  return <Navigate to="/" />;
}
